import ClassicLightTheme from 'foundations-theming-base/stable/classic/light/theme';
import { getDeployedTheme } from '../../utils/getDeployedTheme';
import { getLocalThemeSettings } from '../../utils/getLocalThemeSettings';
import { getCssVariablesTheme, getUseCssVariables } from '../../utils/localCssVariables';
const mergeThemeWithOverrides = (baseTheme, overrides) => {
  return Object.assign({}, baseTheme, {
    color: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.color, overrides.color),
    space: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.space, overrides.space),
    borderRadius: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderRadius, overrides.borderRadius),
    borderWidth: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderWidth, overrides.borderWidth),
    boxShadow: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.boxShadow, overrides.boxShadow),
    typography: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.typography, overrides.typography)
  });
};
export const getDefaultTheme = () => {
  return ClassicLightTheme;
};
export const getTheme = async (themeName, themeMode) => {
  if (themeName === 'classic' || themeName === 'canvas') {
    if (themeMode === 'light') {
      return Promise.resolve(ClassicLightTheme);
    }
  } else if (themeName === 'pink') {
    if (themeMode === 'light') {
      return (await import('./mock-themes/pink/light/theme')).default;
    }
  } else if (themeName === 'next' || themeName === 'trellis') {
    if (themeMode === 'light') {
      return (await import('../../themes/next/light/theme')).default;
    } else if (themeMode === 'dark') {
      return (await import('../../themes/next/dark/theme')).default;
    }
  }
  return undefined;
};
export const getThemeToProvide = async (themeName, themeMode) => {
  const localThemeSettings = getLocalThemeSettings();
  const useCssVariables = getUseCssVariables();
  const overrideTheme = await getLocalThemeOverride(localThemeSettings);
  let theme = undefined;
  if (overrideTheme) {
    theme = overrideTheme;
  } else {
    theme = await getTheme(themeName, themeMode);
  }
  if (theme) {
    if (useCssVariables) {
      return getCssVariablesTheme(theme);
    }
    return theme;
  }
  throw new Error('Unsupported theme and mode combination.');
};
export async function getLocalThemeOverride(themeSettings) {
  if (!themeSettings) {
    return undefined;
  }
  const {
    themeName,
    themeMode,
    themeVersion,
    themeOverrides
  } = themeSettings;
  let baseTheme;
  try {
    if (themeVersion.type === 'builtin' ||
    // pink theme should always be loaded as built-in
    themeName === 'pink' && themeMode === 'light') {
      baseTheme = await getTheme(themeName, themeMode);
    } else {
      baseTheme = await getDeployedTheme({
        themeName,
        themeMode,
        themeVersion
      });
    }
    if (themeOverrides && Object.keys(themeOverrides).length > 0) {
      if (!baseTheme) {
        throw new Error('Unsupported theme and mode combination.');
      }
      return mergeThemeWithOverrides(baseTheme, themeOverrides);
    }
    return baseTheme;
  } catch (error) {
    console.error('Failed to parse local theme override:', error);
  }
  return undefined;
}